import { Widget } from '../base/widget/WidgetInterface'
import { WidgetType } from '../base/widget/WidgetTypes'

export const WidgetSpacer: Widget = {
  type: WidgetType.spacer,
  isFrameless: true,
  title: 'Platzhalter',
  defaultSize: 1,
  minSize: 1,
  maxSize: 0,
  notEditable: ['title'],
  icon: 'ArrowExpandHorizontal'
}

export default WidgetSpacer
